var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccesoriesIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "55px",
    viewBox: "0 0 60 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "accesories-icon--white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-5",
    transform: "translate(-107.000000, -2259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(96.000000, 2261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accesories-icon--white",
    transform: "translate(13.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.126258,50.3830087 C33.4430058,53.7343835 27.9182592,42.3405671 21.5580011,42.3405671 C15.3465771,42.3405671 7.91807404,53.0638226 2.85411309,50.3830087 C-1.16668871,48.2539659 -0.729788547,35.0797316 2.85411309,32.2857278 C10.181913,26.5702326 32.7985781,26.5726156 40.1274583,32.2857278 C43.7125602,35.0794933 44.1953109,48.3443987 40.126252,50.3830087 L40.126258,50.3830087 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.5,
    y1: 37,
    x2: 36.5,
    y2: 44,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40.5,
    x2: 33,
    y2: 40.5,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 33.5,
    x2: 24,
    y2: 33.5,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9888013,28 C21.9888013,26.7411426 22.0139984,25.4822852 21.9888013,24.2259576 C21.9328082,21.6216286 19.8958847,22.7154492 17.8116881,22.7130399 C15.0752842,22.710621 12.3527367,22.7203003 9.62194708,22.545654 C7.68933495,22.4226353 3.86544105,21.901119 3.19555485,19.6028189 C1.91013306,15.1865785 7.28427359,15.5984477 9.90158396,15.3225833 C13.2771749,14.9672361 17.1010688,14.6925643 20.5163178,14",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,37.0001677 C6,37.5521637 5.55243248,38 5,38 C4.4475843,38 4,37.5521805 4,37.0001677 C4,36.4478447 4.44756752,36 5,36 C5.5524157,36 6,36.4478195 6,37.0001677",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,37.0001677 C12,37.5521637 11.5521805,38 11.0001677,38 C10.4478447,38 10,37.5521805 10,37.0001677 C10,36.4478447 10.4478195,36 11.0001677,36 C11.5521637,36 12,36.4478195 12,37.0001677",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,42.9998323 C6,43.5521553 5.55243248,44 5,44 C4.4475843,44 4,43.5521805 4,42.9998323 C4,42.4478363 4.44756752,42 5,42 C5.5524157,42 6,42.4478195 6,42.9998323",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,42.9998323 C12,43.5521553 11.5521805,44 11.0001677,44 C10.4478447,44 10,43.5521805 10,42.9998323 C10,42.4478363 10.4478195,42 11.0001677,42 C11.5521637,42 12,42.4478195 12,42.9998323",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,9.00016773 C44,9.5521637 43.5524325,10 43,10 C42.4475843,10 42,9.55218048 42,9.00016773 C42,8.44784468 42.4475675,8 43,8 C43.5524157,8 44,8.44781952 44,9.00016773",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,21.0001677 C44,21.5524908 43.5524325,22 43,22 C42.4475843,22 42,21.5525075 42,21.0001677 C42,20.4478279 42.4475675,20 43,20 C43.5524157,20 44,20.4478195 44,21.0001677",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "30 27.2861329 30 0 56 0 56 51 38.2407536 51"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesoriesIconWhite);
export default __webpack_public_path__ + "static/media/accesories-icon--white.b04698aa0b6bd62d5ee17c0ec8841b1b.svg";
export { ForwardRef as ReactComponent };